<template>
  <div>
    <sdPageHeader :title="$t('pages.apps.new.title')"> </sdPageHeader>
    <Main>
      <a-row :gutter="25">
        <a-col :sm="24" :xs="24">
          <HorizontalFormStyleWrap>
            <sdCards :title="$t('pages.apps.new.general-setting')">
              <a-form
                :layout="'horizontal'"
                :model="general"
                :label-col="{ lg: 8, md: 9, xs: 24 }"
                :wrapper-col="{ lg: 16, md: 15, xs: 24 }"
                labelAlign="left"
              >
                <a-form-item :label="$t('pages.apps.new.app-name')">
                  <a-input v-model:value="general.name" />
                </a-form-item>
                <a-form-item :label="$t('pages.apps.new.app-url')">
                  <a-input v-model:value="general.url" placeholder="https://localhost" />
                </a-form-item>
              </a-form>
            </sdCards>
          </HorizontalFormStyleWrap>
          <sdButton class="sDash_form-action__btn" type="primary" size="large" @click="saveApp">
            {{ $t('pages.apps.new.save') }}
          </sdButton>
        </a-col>
      </a-row>
    </Main>
  </div>
</template>


<script>
import { HorizontalFormStyleWrap, CheckListWrap } from './Style';
import { Main } from '@/view/styled';
import { useRouter } from 'vue-router';
export default {
  name: 'HorizantalForm',
  components: {
    HorizontalFormStyleWrap,
    CheckListWrap,
    Main,
  },
  data() {
    return {
      general: {
        name: null,
        url: null,
      },
      router: useRouter(),
    };
  },
  methods: {
    saveApp() {
      this.$appAxios.post(this.$endpoints.app_insert, { general: this.general}).then((resp) => {
        if (resp.data.status) {
          this.$message.success('Uygulama Başarıyla Oluşturuldu');
          this.router.push('/applications/detail/' + resp.data.data.app_id + '/general');
        } else {
          this.$message.error(resp.data.message);
        }
      });
    },
  },
};
</script>
